export default __webpack_public_path__ + "static/media/cash-coin.85ff11aa.svg";